import { render, staticRenderFns } from "./userComRelDialog.vue?vue&type=template&id=5c222914&scoped=true"
import script from "./userComRelDialog.vue?vue&type=script&lang=js"
export * from "./userComRelDialog.vue?vue&type=script&lang=js"
import style0 from "./userComRelDialog.vue?vue&type=style&index=0&id=5c222914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c222914",
  null
  
)

export default component.exports